var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-header" }, [
    _c("div", { staticClass: "uesrInfo-hd" }, [
      _c("div", { staticClass: "hdInfo" }, [
        _c("img", {
          staticClass: "adminImg",
          attrs: { src: _vm.hdImg, alt: "" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userHdInfo" }, [
        _c("div", { staticClass: "userHd" }, [
          _c("img", {
            staticClass: "userImg",
            attrs: { src: _vm.userInfo.avatarUrl || _vm.zwt, alt: "" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "userInfoDig" }, [
            _c("div", { staticClass: "userDigImg" }, [
              _c("img", {
                staticClass: "userImg",
                attrs: { src: _vm.userInfo.avatarUrl || _vm.zwt, alt: "" },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "userBorder",
                attrs: { src: _vm.userInfo.border, alt: "" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "userInfoItem", on: { click: _vm.isTo } },
              [
                _c("i", { staticClass: "el-icon-user" }),
                _vm._v(" "),
                _c("span", [_vm._v("个人中心")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "userInfoItem",
                on: {
                  click: function ($event) {
                    return _vm.logout(1)
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-guide" }),
                _vm._v(" "),
                _c("span", [_vm._v("返回前台")]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userName" }, [
          _vm._v(_vm._s(_vm.userInfo.name)),
        ]),
        _vm._v("\n      |\n      "),
        _c(
          "div",
          {
            staticClass: "userLogin",
            on: {
              click: function ($event) {
                return _vm.logout(2)
              },
            },
          },
          [_vm._v("退出")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-wrapper", class: _vm.classObj },
      [
        _vm.device === "mobile" && _vm.sidebar.opened
          ? _c("div", {
              staticClass: "drawer-bg",
              on: { click: _vm.handleClickOutside },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("sidebar", { staticClass: "sidebar-container" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "main-container",
            class: { hasTagsView: _vm.needTagsView },
          },
          [
            _c(
              "div",
              { class: { "fixed-header": _vm.fixedHeader } },
              [_c("navbar")],
              1
            ),
            _vm._v(" "),
            _c("app-main"),
            _vm._v(" "),
            _vm.showSettings
              ? _c("right-panel", [_c("settings")], 1)
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }